import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import ChartContainer from '../../shared/ChartContainer';
import CountByAgeChart, { ChartProp } from './CountByAgeChart';
import DropDownButton, { DropDownMenu } from '../../shared/DropDownButton';
import { useTranslation } from 'react-i18next';

export const filterMenus: DropDownMenu[] = [
    { label: 'Today', value: 'today' },
    { label: 'Week', value: 'week' },
    { label: 'Month', value: 'month' }
];

const data: ChartProp[] = [
    {
        name: '1-10',
        male: 10,
        female: 9,
        unknown: 0
    },
    {
        name: '11-20',
        male: 10,
        female: 12,
        unknown: 4
    },
    {
        name: '21-30',
        male: 30,
        female: 10,
        unknown: 6
    },
    {
        name: '31-40',
        male: 27,
        female: 34,
        unknown: 10
    },
    {
        name: '41-50',
        male: 25,
        female: 20,
        unknown: 5
    },
    {
        name: '51-60',
        male: 15,
        female: 15,
        unknown: 0
    },
    {
        name: '61-70',
        male: 4,
        female: 5,
        unknown: 0
    },
];


export default function CountByAgeCard() {
    const { t } = useTranslation();
    const exportMenus: DropDownMenu[] = [{ label: 'PDF', value: 'pdf' }, { label: 'CSV', value: 'csv' }];

    
    return (
        <Grid item={true}  xs={12} md={12} lg={11} xl={11}>
            <FFPaper
                sx={{
                    alignItems: 'stretch',
                    flexDirection: 'row',
                    minHeight: 360
                }}
            >
                <Stack sx={{ width: '100%' }}>

                    <Stack direction="row" spacing={2} sx={{ pt: 2, pr: 3, pb: 1, pl: 2, flexWrap: 'wrap' }}>
                        <Title big={true} notooltip={true}>Count By Age</Title>
                        <Stack direction="row" spacing={2} sx={{ pr: 1, pb: 1, mb: 1 }}>

                            <DropDownButton boxShadow={false}
                                defaultLabel={t('app_export_data')}
                                color="text.primary"
                                backgroundColor="button.main"
                                fontSize={14}
                                data={exportMenus} />

                            <DropDownButton defaultLabel='Today' fontSize={15} data={filterMenus} border={false} boxShadow={false} />
                        </Stack>

                    </Stack>


                    <Box sx={{
                        pl: 5,
                        pr: 1,
                        pb: 1,
                        width: '100%',
                        height: '100%'
                    }}>
                        <ChartContainer>
                            <CountByAgeChart data={data} />
                        </ChartContainer>
                    </Box>
                </Stack>

            </FFPaper>

        </Grid>
    )
}